export default __webpack_public_path__ + "static/afterglow-banner-522980c957138403fc6b299766b15656.webp";